import rangeUtils from 'utils/rangeUtils';
import selectionUtils from 'utils/selectionUtils';

//todo: Need to write sooo many tests for this.
//todo Explanation: selection on single contenteditable=false element works is a different way.
//CKEDITOR adds a <div> at the bottom of <body/> and set the selection there.
//you may get what you need from `editor.getSelection().getSelectedElement()`
//as of writing this code this funny selection scenario did not exists... the selectionUtils,commands,...are not
//doing the right thing.
//this `div process` is initiated @
//bower_components/ckeditor/core/selection.js:363
//maybe I should remove their handling of it...
//I thought of removing their handling of it but seems like a bad idea... need to take into account selection
//direction and all other kinds of nasty stuff..
const insertHtml = (editor, range, placeholder) => editor.insertHtml(
    `<span contenteditable=false data-wix-placeholder="${placeholder}">[[${placeholder}]]</span>`, 'text', range);

// function init(editor){
//     editor.addCommand('wixWidgetPlaceholder', placeholder);
// }

export default {
    exec: function (editor, placeholderName) {
        let lastTextNodeInRange = null;
        const range = selectionUtils.getSelectedRange(editor).clone();
        if (range.collapsed) {
            insertHtml(editor, range, placeholderName);
        } else if (range.endContainer.type === CKEDITOR.NODE_TYPE) {
            range.endContainer.split(range.endOffset);
            insertHtml(editor, range, placeholderName);
        } else if (lastTextNodeInRange = rangeUtils.findLastNonEmptyTextNode(range)) {
            range.setEnd(lastTextNodeInRange, lastTextNodeInRange.getText().length);
            insertHtml(editor, range.clone().collapse(), placeholderName);
        }
    }
};
